export default __webpack_public_path__ + "static/footer_mb-c30c02b9dfc2ad9bf348f071ea0267ff.svg";